// extracted by mini-css-extract-plugin
export default {"root":"WorkerSuggest_root__lX9IA","user-suggest":"WorkerSuggest_user-suggest__lc4yN","user-avatar":"WorkerSuggest_user-avatar__Be-8G","user-name":"WorkerSuggest_user-name__z-Lqj"};